import { POSITRON } from '@carto/react-basemaps';
import { API_VERSIONS } from '@deck.gl/carto';
import { createSearchParams } from 'react-router-dom';

const manilaCoords = {
  latitude: 14.599512,
  longitude: 120.984222,
};

const searchParams = createSearchParams(window.location.search);
const latitude = parseFloat(searchParams.get('lat'));
const longitude = parseFloat(searchParams.get('lon'));
const zoom = parseInt(searchParams.get('zoom'));

export const initialState = {
  viewState: {
    longitude: longitude || manilaCoords.longitude,
    latitude: latitude || manilaCoords.latitude,
    zoom: zoom || 9,
    pitch: 0,
    bearing: 0,
    dragRotate: false,
    maxZoom: 14,
  },
  basemap: POSITRON,
  credentials: {
    apiVersion: API_VERSIONS.V3,
    apiBaseUrl: 'https://gcp-us-east1.api.carto.com',
  },
  googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY, // only required when using a Google Basemap
  geocoderApiKey: process.env.REACT_APP_GEOCODER_API_KEY,
  googleMapId: '', // only required when using a Google Custom Basemap
};
